import { render, staticRenderFns } from "./VitySelect.vue?vue&type=template&id=08bbbad8"
import script from "./VitySelect.vue?vue&type=script&lang=js"
export * from "./VitySelect.vue?vue&type=script&lang=js"
import style0 from "./VitySelect.vue?vue&type=style&index=0&id=08bbbad8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports